var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar container container--padding"},[_c('div',{staticClass:"row"},[_c('SidebarNav',{attrs:{"links":_vm.links}}),_c('RouterView',{staticClass:"col--10 card card__body"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }